module.exports = __webpack_public_path__ + "static/media/Drone.55265183.svg";